import {
  formatApiDateTime,
  buildTeamOrderString,
  buildStageGroupTeamIds
} from '@/api/wheel-battle/format-utils'

/**
 * 创建父场次表单 → AdminCreateBMMatchWheelBattleParentGame 入参
 */
export function buildCreateParentGameParams(options) {
  var opts = options || {}
  var form = opts.form || {}
  var groupName = form.groupName || ''
  var groupTeams = opts.groupTeams || form.groupTeams || []

  return {
    matchId: opts.matchId || '',
    stageId: opts.stageId || form.roundId || '',
    groupId: form.groupId || '',
    name: groupName ? groupName + '车轮战' : undefined,
    beginDate: formatApiDateTime(form.beginDate),
    endDate: opts.endDate || undefined,
    fieldId: form.pitchId || '',
    location: form.stadiumName || '',
    teamOrder: opts.teamOrder || buildTeamOrderString(groupTeams)
  }
}

/**
 * 基本信息表单 → AdminUpdateBMMatchWheelBattleParentGame 入参
 */
export function buildUpdateParentGameParams(options) {
  var opts = options || {}
  var form = opts.form || {}
  var groupName = form.groupName || ''
  var name = opts.name
  if (!name && groupName) {
    name = groupName + '车轮战'
  }

  return {
    gameId: opts.gameId || '',
    name: name,
    beginDate: formatApiDateTime(form.beginDate),
    endDate: opts.endDate || undefined,
    fieldId: form.pitchId || '',
    location: form.stadiumName || '',
    teamOrder: opts.teamOrder || buildTeamOrderString(opts.teams)
  }
}

/**
 * 更新单支球队队服颜色 → AdminUpdateBMMatchWheelBattleParentGameTeamClothesColor 入参
 */
export function buildUpdateTeamClothesColorParams(options) {
  var opts = options || {}
  return {
    gameId: opts.gameId || '',
    teamId: opts.teamId || '',
    clothesColor: opts.clothesColor != null ? opts.clothesColor : ''
  }
}

/**
 * 编辑出赛球队 → AdminUpdateBMMatchStageGroupTeams 入参
 */
export function buildUpdateStageGroupTeamsParams(options) {
  var opts = options || {}
  return {
    matchId: opts.matchId || '',
    stageId: opts.stageId || '',
    groupId: opts.groupId || '',
    teamIds: opts.teamIds != null
      ? opts.teamIds
      : buildStageGroupTeamIds(opts.teams || opts.participatingTeams)
  }
}

/**
 * @deprecated 车轮战编辑出赛球队已改用 AdminUpdateBMMatchStageGroupTeams
 */
export function buildUpdateTeamOrderParams(options) {
  var opts = options || {}
  return {
    gameId: opts.gameId || '',
    teamOrder: buildTeamOrderString(opts.teams || opts.participatingTeams)
  }
}

/**
 * 创建子场次 → AdminCreateBMMatchWheelBattleChildGame 入参
 */
export function buildCreateChildGameParams(options) {
  var opts = options || {}
  var payload = opts.payload || {}
  var homeTeam = payload.homeTeam || {}
  var awayTeam = payload.awayTeam || {}
  var params = {
    gameId: opts.gameId || opts.parentGameId || ''
  }
  if (homeTeam.id || opts.homeTeamId) {
    params.homeTeamId = homeTeam.id || opts.homeTeamId
  }
  if (awayTeam.id || opts.awayTeamId) {
    params.awayTeamId = awayTeam.id || opts.awayTeamId
  }
  if (opts.restartConfirmed !== undefined && opts.restartConfirmed !== null && opts.restartConfirmed !== '') {
    params.restartConfirmed = opts.restartConfirmed
  }
  return params
}

/**
 * 确认子场次比分 → AdminConfirmBMMatchWheelBattleChildGameResult 入参
 */
function buildChildGameScoreParams(options) {
  var opts = options || {}
  return {
    gameId: opts.gameId || opts.childGameId || '',
    homeScore: parseInt(opts.homeScore, 10) || 0,
    awayScore: parseInt(opts.awayScore, 10) || 0
  }
}

/**
 * 确认子场次比分 → AdminConfirmBMMatchWheelBattleChildGameResult 入参
 */
export function buildConfirmChildGameResultParams(options) {
  return buildChildGameScoreParams(options)
}

/**
 * 修改已完赛子场次比分 → AdminUpdateBMMatchWheelBattleChildGameResult 入参
 */
export function buildUpdateChildGameResultParams(options) {
  return buildChildGameScoreParams(options)
}

/**
 * 删除子场次 → AdminDeleteBMMatchWheelBattleChildGame 入参
 */
export function buildDeleteChildGameParams(options) {
  var opts = options || {}
  return {
    gameId: opts.gameId || opts.childGameId || ''
  }
}

/**
 * 结束父场次 → AdminFinishBMMatchWheelBattleParentGame 入参
 */
export function buildFinishParentGameParams(options) {
  var opts = options || {}
  return {
    gameId: opts.gameId || opts.parentGameId || ''
  }
}

/**
 * 重启父场次 → AdminRestartBMMatchWheelBattleParentGame 入参
 */
export function buildRestartParentGameParams(options) {
  var opts = options || {}
  return {
    gameId: opts.gameId || opts.parentGameId || ''
  }
}

/**
 * 足球技术统计 → BMMatchOrganizationUpdateBMGameEvents 入参
 */
export function buildUpdateFootballGameEventsParams(options) {
  var opts = options || {}
  var form = opts.form || {}
  return {
    playerId: opts.playerId || '',
    teamId: opts.teamId || '',
    gameId: opts.gameId || '',
    goal: parseInt(form.goalCount, 10) || 0,
    assist: parseInt(form.assistCount, 10) || 0,
    red: parseInt(form.redCardCount, 10) || 0,
    yellow: parseInt(form.yellowCardCount, 10) || 0,
    ownGoal: parseInt(form.ownGoalCount, 10) || 0
  }
}
